module.exports = __webpack_public_path__ + "img/shop_bg8.50f5ca40.png";